// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Amount,
    AmountFromJSON,
    AmountToJSON,
    StatusItemDetail,
    StatusItemDetailFromJSON,
    StatusItemDetailToJSON,
} from './';

/**
 * 
 * @export
 * @interface StatusItem
 */
export interface StatusItem {
    /**
     * The service line control number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof StatusItem
     */
    serviceLineControlNumber?: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof StatusItem
     */
    chargeAmount?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof StatusItem
     */
    paidAmount?: Amount;
    /**
     * The number of paid units
     * OpenAPI data type: {number}
     * @type {number}
     * @memberof StatusItem
     */
    paidUnits?: number;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof StatusItem
     */
    fromDateOfService?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof StatusItem
     */
    throughDateOfService?: string;
    /**
     * The procedure code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof StatusItem
     */
    procedureCode?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof StatusItem
     */
    modifierCode1?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof StatusItem
     */
    modifierCode2?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof StatusItem
     */
    modifierCode3?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof StatusItem
     */
    modifierCode4?: string;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<StatusItemDetail>}
     * @memberof StatusItem
     */
    details?: Array<StatusItemDetail>;
}

export function StatusItemFromJSON(json: any): StatusItem {
    return {
            'serviceLineControlNumber': !exists(json, 'serviceLineControlNumber') ? undefined : json['serviceLineControlNumber'],
            'chargeAmount': !exists(json, 'chargeAmount') ? undefined : AmountFromJSON(json['chargeAmount']),
            'paidAmount': !exists(json, 'paidAmount') ? undefined : AmountFromJSON(json['paidAmount']),
            'paidUnits': !exists(json, 'paidUnits') ? undefined : json['paidUnits'],
            'fromDateOfService': !exists(json, 'fromDateOfService') ? undefined : json['fromDateOfService'],
            'throughDateOfService': !exists(json, 'throughDateOfService') ? undefined : json['throughDateOfService'],
            'procedureCode': !exists(json, 'procedureCode') ? undefined : json['procedureCode'],
            'modifierCode1': !exists(json, 'modifierCode1') ? undefined : json['modifierCode1'],
            'modifierCode2': !exists(json, 'modifierCode2') ? undefined : json['modifierCode2'],
            'modifierCode3': !exists(json, 'modifierCode3') ? undefined : json['modifierCode3'],
            'modifierCode4': !exists(json, 'modifierCode4') ? undefined : json['modifierCode4'],
            'details': !exists(json, 'details') ? undefined : (json['details'] as Array<any>).map(StatusItemDetailFromJSON),
    };

}

export function StatusItemToForm(value?: StatusItem): any {
    let jsonVal = StatusItemToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function StatusItemToJSON(value?: StatusItem): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'serviceLineControlNumber': cleanupBlankValuesForBackend(value.serviceLineControlNumber),
            'chargeAmount': AmountToJSON(value.chargeAmount),
            'paidAmount': AmountToJSON(value.paidAmount),
            'paidUnits': cleanupBlankValuesForBackend(value.paidUnits),
            'fromDateOfService': cleanupBlankValuesForBackend(value.fromDateOfService),
            'throughDateOfService': cleanupBlankValuesForBackend(value.throughDateOfService),
            'procedureCode': cleanupBlankValuesForBackend(value.procedureCode),
            'modifierCode1': cleanupBlankValuesForBackend(value.modifierCode1),
            'modifierCode2': cleanupBlankValuesForBackend(value.modifierCode2),
            'modifierCode3': cleanupBlankValuesForBackend(value.modifierCode3),
            'modifierCode4': cleanupBlankValuesForBackend(value.modifierCode4),
            'details': (value.details === undefined || value.details === null) ? undefined : (value.details as Array<any>).map(StatusItemDetailToJSON),
    };
}


